import styled from 'styled-components';

export const SkelletonCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  height: 60px;
  padding: 10px;

  .rank {
    border-radius: 4px;
    width: 38px;
    height: 38px;
    background: ${({ theme }) => theme.colors.gray300};
  }

  .logo {
    width: 40px;
    height: 26px;
    background: ${({ theme }) => theme.colors.gray300};
    margin-left: 45px;
  }

  .companyInfo {
    display: flex;
    flex: 1;
    flex-direction: column;

    & > p {
      background: ${({ theme }) => theme.colors.gray300};
      height: 16px;
      margin-left: 44px;
    }

    & > p:first-of-type {
      width: 87px;
      margin-bottom: 3px;
    }

    & > p:nth-of-type(2) {
      width: 113px;
    }
  }

  .data {
    background: ${({ theme }) => theme.colors.gray300};
    width: 87px;
    height: 16px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #ebebeb;
  }

  @media screen and (max-width: 1200px) {
    .logo {
      width: 28px;
      height: 17px;
      margin-left: 15px;
    }

    .companyInfo {
      display: flex;
      flex: 1;
      flex-direction: column;

      & > p {
        margin-left: 18px;
      }

      & > p:first-of-type {
        margin-bottom: 3px;
      }
    }
  }
`;
